import { render, staticRenderFns } from "./arrows-right-outlined.vue?vue&type=template&id=3ae63f4f&scoped=true&"
var script = {}
import style0 from "./arrows-right-outlined.vue?vue&type=style&index=0&id=3ae63f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae63f4f",
  null
  
)

export default component.exports